<template>
	<div>
		<template v-for="(actor, id) of actorsToShowHorizontally">
			<div :class="avatarClasses(actor)">
				<!-- @vue-expect-error -->
				<component
					:is="tagName"
					:href="actorHref(id)"
					data-remote="true"
					class="Avatar__image"
					:style="`background-image: url(${actor.imgPath})`"
				>
					<div class="OverlayContainer__content" v-if="showOverlay">
						<!-- @vue-expect-error -->
						{{ actor.names[locale] || Object.values(actor.names)[0] }}
					</div>
					<span
						v-if="isChair(actor)"
						class="Avatar__icon senaryon-icon senaryon-icon-rating-star"
						:title="chairNameInGame"
					></span>
				</component>
				<div v-if="showOnlineStatus" class="Avatar__online-status">
					<!-- @vue-expect-error -->
					<div
						:class='`status circle-${actor.isOnline ? "online" : "offline"}`'
					></div>
				</div>
			</div>
			<component
				v-if="showNameNextToAvatar"
				:is="tagName"
				:href="actorHref(id)"
				data-remote="true"
			>
				<!-- @vue-expect-error -->
				{{ actor.names[locale] || Object.values(actor.names)[0] }}
				<br>
			</component>
		</template>

		<span v-if="actorsToShowInDropdown" class="OverlayContainer">
			<span
				:class='`AvatarOverflow AvatarOverflow--${size} ${withSmallOverlap ? " AvatarOverflow--with-small-overlap" : ""}`'
			>
				<span>+{{ Object.keys(actorsToShowInDropdown).length }}</span>
				<div class="OverlayContainer__content">
					<div v-for="(actor, id, index) of actorsToShowInDropdown">
						<div :class="avatarClasses(actor, true)">
							<div
								class="Avatar__image"
								:style="`background-image: url(${actor.imgPath})`"
							>
								<span
									v-if="isChair(actor)"
									class="Avatar__icon senaryon-icon senaryon-icon-rating-star"
									:title="chairNameInGame"
								></span>
							</div>
						</div>
						{{ actor.names[locale] || Object.values(actor.names)[0] }}
						<hr v-if="index != Object.keys(actorsToShowInDropdown).length - 1">
					</div>
				</div>
			</span>
		</span>

		<template v-for="(actor, id) of actorsToShowAsStackedSets">
			<div :class="avatarSetClasses">
				<div :class="avatarClasses(actor)">
					<!-- @vue-expect-error -->
					<component
						:is="tagName"
						:href="actorHref(id)"
						data-remote="true"
						class="Avatar__image"
						:style="`background-image: url(${actor.imgPath})`"
					>
						<div class="OverlayContainer__content" v-if="showOverlay">
							<!-- @vue-expect-error -->
							{{ actor.names[locale] || Object.values(actor.names)[0] }}
						</div>
						<span
							v-if="isChair(actor)"
							class="Avatar__icon senaryon-icon senaryon-icon-rating-star"
							:title="chairNameInGame"
						></span>
					</component>
					<div v-if="showOnlineStatus" class="Avatar__online-status">
						<!-- @vue-expect-error -->
						<div
							:class='`status circle-${actor.isOnline ? "online" : "offline"}`'
						></div>
					</div>
				</div>
				<div v-if="principalGroupFor(actor)" :class="sharedAvatarClasses()">
					<!-- Don't determine whether the group is a chair group -->
					<component
						:is="tagName"
						:href="actorHref(principalGroupFor(actor).id)"
						data-remote="true"
						class="Avatar__image"
						:style="`background-image: url(${principalGroupFor(actor).imgPath})`"
					>
						<div class="OverlayContainer__content" v-if="showOverlay">
							{{
								principalGroupFor(actor).names[locale] ||
									Object.values(principalGroupFor(actor).names)[0]
							}}
						</div>
					</component>
				</div>
			</div>
		</template>

		<template v-if="!actorsToShow.length && emptyListMessage.length">
			{{ emptyListMessage }}
		</template>
	</div>
</template>

<script>
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		srvOptions: Object,
		srvActorId: Number,
		srvActorIds: Object,
		srvIdentifier: String,
	},
	data: function () {
		return {
			/** @type {any} */
			options: this.srvOptions || {},
			actorIds:
				this.srvActorIds || (this.srvActorId ? [this.srvActorId] : null) || [],
			identifier: this.srvIdentifier,
		};
	},
	computed: {
		actorsToShow() {
			// Convert to array for functions below
			return Object.entries(VueStore.getters.gameActors(this.actorIds));
		},
		actorsToShowHorizontally() {
			if (this.showAsStackedAvatarSet) {
				return [];
			}
			if (this.options.maxItems !== undefined) {
				return Object.fromEntries(
					this.actorsToShow.slice(0, this.options.maxItems - 1),
				);
			} else {
				return Object.fromEntries(this.actorsToShow);
			}
		},
		actorsToShowInDropdown() {
			if (this.options.maxItems === undefined || this.showAsStackedAvatarSet) {
				return null;
			}
			// else
			const slicedActors = this.actorsToShow.slice(
				this.options.maxItems - 1,
				Object.fromEntries(this.actorsToShow).length,
			);
			return slicedActors.length ? Object.fromEntries(slicedActors) : null;
		},
		actorsToShowAsStackedSets() {
			if (!this.showAsStackedAvatarSet) {
				return [];
			}
			return Object.fromEntries(this.actorsToShow);
		},
		showAsStackedAvatarSet() {
			return this.options.showAsStackedAvatarSet;
		},
		tagName() {
			return this.options.showLink ? "a" : "div";
		},
		size() {
			return this.options.size || "x-small";
		},
		showOnlineStatus() {
			return this.options.showOnlineStatus;
		},
		showNameNextToAvatar() {
			return this.options.showNameNextToAvatar;
		},
		showOverlay() {
			return !this.options.noOverlay && !this.showNameNextToAvatar;
		},
		withSmallOverlap() {
			return this.options.withSmallOverlap;
		},
		locale() {
			return I18n.locale;
		},
		chairNameInGame() {
			if (pp.currentActorId === undefined) {
				return "chair"; // For the CMS
			}
			// @ts-expect-error
			const chairNamesHash = pp.groupTypeNames.chair;
			// @ts-expect-error
			return chairNamesHash[I18n.locale]
				? // @ts-expect-error
					chairNamesHash[I18n.locale].one
				: // @ts-expect-error
					Object.values(chairNamesHash)[0].one;
		},
		emptyListMessage() {
			return this.options.emptyListMessage || "";
		},
		avatarSetClasses() {
			return `AvatarSet AvatarSet--${this.size}-over-${this.size}`;
		},
	},
	mounted() {
		$(this.$el).css("display", "inline-block");
		if (this.identifier) {
			// pp.log("got id", this.identifier)
			pp.vue.bus.$on("actor-list-items-UPDATE", this.handleIncomingActorIds);
		}
	},
	beforeDestroy() {
		if (this.identifier) {
			pp.vue.bus.$off("actor-list-items-UPDATE", this.handleIncomingActorIds);
		}
	},
	methods: {
		avatarClasses(actor, skipSmallOverlap) {
			// Need to create a clone so that the class for chair is not added to all
			const elClasses = Object.assign(
				[],
				this.sharedAvatarClasses(skipSmallOverlap),
			);

			if (this.isChair(actor)) {
				elClasses.push("Avatar--bordered-blue");
			}
			return elClasses.join(" ");
		},
		principalGroupFor(actor) {
			return VueStore.getters.actorData(actor.principalGroupId); // Will be null if the Actor has no principal group
		},
		isChair(actor) {
			return (
				!this.options.omitChairIcon &&
				this.size != "xx-small" &&
				actor.functions.includes("chair")
			);
		},
		actorHref(actorId) {
			return this.options.showLink ? `/actors/${actorId}` : null;
		},
		handleIncomingActorIds(payload) {
			// pp.log("incoming", payload, this.identifier);
			if (payload.identifier != this.identifier) {
				return;
			}
			// pp.log("setting", this.identifier, payload.actorIds, payload.actorIdToAdd);
			if (payload.actorIds) {
				this.actorIds = payload.actorIds;
			} else if (payload.actorIdToAdd) {
				// @ts-expect-error
				this.actorIds.push(payload.actorIdToAdd);
			}
		},
		sharedAvatarClasses(skipSmallOverlap) {
			const elClasses = ["Avatar Avatar--bordered"];
			elClasses.push(`Avatar--${this.size}`);
			if (!skipSmallOverlap && this.withSmallOverlap) {
				elClasses.push("Avatar--with-small-overlap");
			}
			if (this.showOverlay) {
				elClasses.push("OverlayContainer OverlayContainer--right");
			}
			elClasses.push(this.options.extraClasses);
			return elClasses;
		},
	},
};
</script>
